/**
 * It takes a color and returns a gradient
 * @param color - The color you want to use for the gradient.
 */
export const getGradient = (color) => `linear-gradient(0deg, ${color} 0%, ${color} 100%)`;
